import { TOUR_GUILD_HIDDEN, TOUR_GUILD_SHOW } from "./action.type";
import { HomeAction, HomeState } from "./types";

const initState: HomeState = {
  showTourGuild: true,
};

const homeReducer = (state = initState, action: HomeAction) => {
  switch (action.type) {
    case TOUR_GUILD_SHOW:
      return {
        ...state,
        showTourGuild: true,
      };
    case TOUR_GUILD_HIDDEN:
      return {
        ...state,
        showTourGuild: false,
      };
    default:
      return {
        ...state,
      };
  }
};

export default homeReducer;
